import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const AdminUsersApi = createApi({
    reducerPath: 'AdminUsersApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT,
        prepareHeaders: setJwtToken
    }),
    tagTypes: ['USER'],
    endpoints: builder => ({
        getAllUsers: builder.query<any[], void>({
            query: () => ({ url: '/users' }),
            providesTags: ['USER']
        })
    })
})

export const { useGetAllUsersQuery } = AdminUsersApi
